import { memo } from 'react';
import SVGBase, { type SVGComponentProps } from './SVGBase';

const path = <path d="M5.28018 7.90028C5.12702 7.90003 4.97854 7.95306 4.86018 8.05028C4.58893 8.28058 4.55327 8.68618 4.78018 8.96028L11.5002 16.9603C11.6256 17.1058 11.8081 17.1895 12.0002 17.1895C12.1923 17.1895 12.3748 17.1058 12.5002 16.9603L19.2302 8.96028C19.4483 8.68336 19.406 8.28303 19.1347 8.05788C18.8635 7.83273 18.4622 7.86485 18.2302 8.13028L12.0302 15.5303L5.78018 8.13028C5.65854 7.97979 5.47361 7.89472 5.28018 7.90028Z" />;

function ArrowDown({
  className,
  title = 'Arrow Down',
}: SVGComponentProps) {
  return (
    <SVGBase
      className={className}
      labeledBy="arrow-down-svg"
      path={path}
      title={title}
      viewBox='0 0 24 24'
    />
  );
}

export default memo(ArrowDown);
